/**
 * Loads Shopify Product Recommendations via GET /recommendations/products.json
 * and renders 40x40 circular product images (same source as "You may also like").
 */

function getFeaturedImageSrc(p) {
  if (!p) return '';
  if (typeof p.featured_image === 'string') return p.featured_image;
  if (p.featured_image && typeof p.featured_image.src === 'string') return p.featured_image.src;
  if (p.featured_image && typeof p.featured_image === 'object' && p.featured_image.url) return p.featured_image.url;
  if (Array.isArray(p.images) && p.images.length) {
    const img = p.images[0];
    if (typeof img === 'string') return img;
    if (img && typeof img.src === 'string') return img.src;
    if (img && img.url) return img.url;
  }
  return '';
}

class ProductRelatedPills extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const endpoint = this.dataset.endpoint;
    if (!productId || !endpoint) return;

    const run = () => {
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', this.dataset.limit || '6');
      url.searchParams.set('intent', 'related');

      fetch(url.toString())
        .then((response) => response.json())
        .then((data) => {
          const products = data && data.products;
          if (!products || !products.length) {
            this.remove();
            return;
          }

          const heading = this.dataset.heading;
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'js product-form__input product-form__input--related-products';

          if (heading) {
            const legend = document.createElement('legend');
            legend.className = 'form__label';
            legend.textContent = heading;
            fieldset.appendChild(legend);
          }

          const list = document.createElement('div');
          list.className = 'product-form__related-links';
          list.setAttribute('role', 'list');

          products.forEach((p) => {
            if (!p || !p.url) return;
            const link = document.createElement('a');
            link.href = p.url;
            link.className = 'product-form__related-link product-form__related-link--thumb';
            link.setAttribute('role', 'listitem');
            link.setAttribute('title', p.title || '');

            const imgSrc = getFeaturedImageSrc(p);
            if (imgSrc) {
              const img = document.createElement('img');
              img.className = 'product-form__related-link__img';
              img.src = imgSrc;
              img.width = 40;
              img.height = 40;
              img.alt = p.title || '';
              img.loading = 'lazy';
              img.decoding = 'async';
              link.appendChild(img);
            } else {
              const ph = document.createElement('span');
              ph.className = 'product-form__related-link__placeholder';
              ph.setAttribute('aria-hidden', 'true');
              const t = (p.title || '?').trim();
              ph.textContent = t ? t.charAt(0).toUpperCase() : '?';
              link.appendChild(ph);
            }

            const sr = document.createElement('span');
            sr.className = 'visually-hidden';
            sr.textContent = p.title || '';
            link.appendChild(sr);

            list.appendChild(link);
          });

          if (!list.children.length) {
            this.remove();
            return;
          }

          fieldset.appendChild(list);
          this.innerHTML = '';
          this.appendChild(fieldset);
          this.classList.add('product-related-pills--loaded');
        })
        .catch(() => {
          this.remove();
        });
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.unobserve(this);
        run();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(this);
  }
}

customElements.define('product-related-pills', ProductRelatedPills);
